var _circle, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFileImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 84,
    r: 84,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2682_15203)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 137H117.631C119.346 137 120.737 135.61 120.737 133.895V34.1055C120.737 32.3904 119.346 31 117.631 31H51.1055C49.3904 31 48 32.3904 48 34.1055V109V110.61V133C48 135.209 49.7909 137 52 137H74.3897H92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.1565,
    height: 2.24527,
    rx: 1.12263,
    transform: "matrix(1 -3.38451e-08 -1.95755e-06 1 75.1376 75.2574)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.1387,
    height: 2.24527,
    rx: 1.12263,
    transform: "matrix(1 -3.38451e-08 -1.95755e-06 1 75.0164 80.0516)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    transform: "matrix(1 0 -1.92371e-06 1 60 73)",
    fill: "url(#paint0_linear_2682_15203)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.1565,
    height: 2.24527,
    rx: 1.12263,
    transform: "matrix(1 -3.38451e-08 -1.95755e-06 1 75.1376 59.2574)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.1387,
    height: 2.24527,
    rx: 1.12263,
    transform: "matrix(1 -3.38451e-08 -1.95755e-06 1 75.0164 64.0516)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    transform: "matrix(1 0 -1.92371e-06 1 60 57)",
    fill: "url(#paint1_linear_2682_15203)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.1565,
    height: 2.24527,
    rx: 1.12263,
    transform: "matrix(1 -3.38451e-08 -1.95755e-06 1 75.1376 91.2574)",
    fill: "#C9D1DA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.1387,
    height: 2.24527,
    rx: 1.12263,
    transform: "matrix(1 -3.38451e-08 -1.95755e-06 1 75.0164 96.0516)",
    fill: "#C9D1DA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    transform: "matrix(1 0 -1.92371e-06 1 60 89)",
    fill: "url(#paint2_linear_2682_15203)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2682_15203)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 132,
    r: 16,
    fill: "#A6ADB6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-outside-1_2682_15203",
    maskUnits: "userSpaceOnUse",
    x: 73.202,
    y: 120.89,
    width: 21.2131,
    height: 21.2133,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 73.202,
    y: 120.89,
    width: 21.2131,
    height: 21.2133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8968 136.594C88.2392 136.321 88.2912 135.818 88.013 135.472C87.7348 135.125 87.2317 135.066 86.8893 135.339L84.4426 137.334L84.4426 123.218C84.4432 122.777 83.9908 122.44 83.5496 122.433C83.1084 122.425 82.5225 122.777 82.5218 123.218L82.5218 137.271L79.9941 135.286C79.6476 135.008 79.1453 135.06 78.8723 135.402C78.5994 135.745 78.659 136.248 79.0056 136.526L82.9762 139.713C83.2698 139.949 83.6843 139.952 83.9743 139.721L87.8968 136.594Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8968 136.594C88.2392 136.321 88.2912 135.818 88.013 135.472C87.7348 135.125 87.2317 135.066 86.8893 135.339L84.4426 137.334L84.4426 123.218C84.4432 122.777 83.9908 122.44 83.5496 122.433C83.1084 122.425 82.5225 122.777 82.5218 123.218L82.5218 137.271L79.9941 135.286C79.6476 135.008 79.1453 135.06 78.8723 135.402C78.5994 135.745 78.659 136.248 79.0056 136.526L82.9762 139.713C83.2698 139.949 83.6843 139.952 83.9743 139.721L87.8968 136.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.013 135.472L88.325 135.221L88.325 135.221L88.013 135.472ZM87.8968 136.594L88.1462 136.906L88.1462 136.906L87.8968 136.594ZM86.8893 135.339L86.6399 135.026L86.6365 135.029L86.8893 135.339ZM84.4426 137.334H84.0426C84.0426 137.488 84.1315 137.629 84.271 137.695C84.4105 137.761 84.5757 137.742 84.6954 137.644L84.4426 137.334ZM84.4426 123.218L84.0426 123.217L84.0426 123.218L84.4426 123.218ZM83.5496 122.433L83.5563 122.033L83.5563 122.033L83.5496 122.433ZM82.5218 123.218L82.1218 123.217L82.1218 123.218L82.5218 123.218ZM82.5218 137.271L82.2747 137.586C82.3952 137.68 82.559 137.698 82.6967 137.631C82.8344 137.564 82.9218 137.424 82.9218 137.271H82.5218ZM79.9941 135.286L79.7437 135.598L79.7471 135.601L79.9941 135.286ZM78.8723 135.402L78.5596 135.153L78.8723 135.402ZM79.0056 136.526L79.256 136.214L79.256 136.214L79.0056 136.526ZM82.9762 139.713L82.7259 140.025L82.7259 140.025L82.9762 139.713ZM83.9743 139.721L83.7249 139.408L83.9743 139.721ZM87.7011 135.722C87.8442 135.901 87.8123 136.149 87.6475 136.281L88.1462 136.906C88.6661 136.492 88.7382 135.736 88.325 135.221L87.7011 135.722ZM87.1387 135.651C87.3044 135.519 87.5573 135.543 87.7011 135.722L88.325 135.221C87.9123 134.707 87.159 134.612 86.64 135.026L87.1387 135.651ZM84.6954 137.644L87.1421 135.649L86.6365 135.029L84.1898 137.024L84.6954 137.644ZM84.0426 123.218L84.0426 137.334L84.8426 137.334L84.8426 123.218L84.0426 123.218ZM83.5429 122.833C83.669 122.835 83.805 122.886 83.9056 122.97C84.0045 123.052 84.0427 123.142 84.0426 123.217L84.8426 123.219C84.8431 122.853 84.6554 122.553 84.418 122.355C84.1822 122.159 83.8714 122.038 83.5563 122.033L83.5429 122.833ZM82.9218 123.219C82.9219 123.182 82.9522 123.089 83.1009 122.984C83.2437 122.883 83.419 122.83 83.5429 122.833L83.5563 122.033C83.2391 122.027 82.9008 122.146 82.6401 122.33C82.3854 122.51 82.1224 122.813 82.1218 123.217L82.9218 123.219ZM82.9218 137.271L82.9218 123.218L82.1218 123.218V137.271H82.9218ZM79.7471 135.601L82.2747 137.586L82.7689 136.957L80.2412 134.971L79.7471 135.601ZM79.1851 135.652C79.3165 135.487 79.5654 135.455 79.7438 135.598L80.2445 134.974C79.7297 134.561 78.9741 134.633 78.5596 135.153L79.1851 135.652ZM79.256 136.214C79.0769 136.07 79.053 135.817 79.1851 135.652L78.5596 135.153C78.1458 135.672 78.2411 136.425 78.7552 136.838L79.256 136.214ZM83.2266 139.401L79.256 136.214L78.7552 136.838L82.7259 140.025L83.2266 139.401ZM83.7249 139.408C83.5844 139.52 83.3774 139.522 83.2266 139.401L82.7259 140.025C83.1621 140.375 83.7842 140.384 84.2236 140.034L83.7249 139.408ZM87.6475 136.281L83.7249 139.408L84.2236 140.034L88.1462 136.906L87.6475 136.281Z",
    fill: "white",
    mask: "url(#path-13-outside-1_2682_15203)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2682_15203",
    x: 32,
    y: 21,
    width: 96.7369,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2682_15203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2682_15203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2682_15203",
    x: 52,
    y: 106,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2682_15203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2682_15203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2682_15203",
    x1: 6.23586,
    y1: 11.7492,
    x2: 5.27774,
    y2: 0.249496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2682_15203",
    x1: 6.23586,
    y1: 11.7492,
    x2: 5.27774,
    y2: 0.249496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2682_15203",
    x1: 6.23586,
    y1: 11.7492,
    x2: 5.27774,
    y2: 0.249496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileImage);
export default __webpack_public_path__ + "static/media/download-file-image.b7c1f7b5f90fec4c43c3f2cc06c9aa42.svg";
export { ForwardRef as ReactComponent };